var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.localTelemetry && _vm.localTelemetry.length > 0)?_c('cloud-panel',{attrs:{"ignore-null-value":true,"title":_vm.__('telemetry'),"data":_vm.telemetryInfo,"searchable":true},on:{"search":_vm.filterTelemetries}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }